/**
 * Created by caoyu on 2021/12/4.
 */
import Vue from 'vue'

import FileUploadCommon from "./FileUploadCommon.vue"
import FileUploadImage from "./FileUploadImage.vue"
import FileUploadImage2 from "./FileUploadImage2.vue"


Vue.component('FileUploadCommon', FileUploadCommon);
Vue.component('FileUploadImage', FileUploadImage);
Vue.component('FileUploadImage2', FileUploadImage2);



// WEBPACK FOOTER //
// ./src/common/upload/fileupload.js